import { Link } from 'react-router-dom';
import SourceManager from '../components/SourceManager.jsx';

export default function DevSources() {
  return (
    <div className="max-w-page mx-auto px-4 sm:px-6 py-8">
      <Link
        to="/admin/dev"
        className="text-[12px] text-hxd-muted hover:text-hxd-orange transition-colors"
      >
        ← Back to Dev Dashboard
      </Link>
      <div className="mt-4">
        <SourceManager apiBase="/dev/sources" showLastError={false} />
      </div>
    </div>
  );
}
